import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SigninComponent } from './common/signin/signin.component';
import { AuthGuardService } from './services/auth/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'signin',
    pathMatch: 'full',
  },
  {
    path: 'signin',
    component: SigninComponent,
  },
  {
    path: 'select-program',
    loadComponent: () =>
      import('./common/programs-list/programs-list.component').then(m => m.ProgramsListComponent),
  },
  {
    path: 'program-members',
    loadComponent: () =>
      import('./common/program-members/components/program-members.component').then(
        m => m.ProgramMembersComponent
      ),
  },

  {
    path: 'hubAdmin',
    canActivate: [AuthGuardService],
    loadComponent: () =>
      import('./hubadmin/core/layout/layout.component').then(m => m.LayoutComponent),
    loadChildren: () => import('./hubadmin/hubadmin.routes').then(m => m.HUBADMIN_ROUTES),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
